import React from "react";
import styles from "./NewHero.module.css";
import { useColorModeValue } from "../../hooks/useColorModeValue";
import { ReactComponent as CutSvg } from "../../assets/hero/cut.svg";
import  GdgocSzabist from "../../assets/hero/gdg-white.png"


const NewHero = () => {
  return (
    <section className={styles["hero"]}>
      <div className={styles["hero-info"]}>
        <div className={styles["gdg-logo"]}>
          <img
            className={styles["desktop-img"]}
            draggable={false}
            src={GdgocSzabist}
            alt="Google Developers Groups, On Campus Szabist"
          />
          <div
            className={useColorModeValue(
              styles["mobile-img"],
              `${styles["mobile-img"]} ${styles["img-dark"]}`
            )}
          >
            <img width={275}
            draggable={false}
            src={GdgocSzabist}
            alt="Google Developers Groups, On Campus Szabist"
          />
          </div>
        </div>
        <div className={styles["heading"]}>
          <h1
            style={{
              color: useColorModeValue(
                "rgba(97, 97, 97, 1)",
                "rgba(232, 234, 237, 1)"
              ),
            }}
          >
            <p>
              Discover,{" "}
              <span className={styles["cut-mask"]}>
                <CutSvg />
              </span>
            </p>{" "}
            Learn,
          </h1>
          <h1
            style={{
              color: useColorModeValue("black", "rgba(255, 255, 255, 1)"),
            }}
          >
           And Innovate
          </h1>
        </div>
        <div className={styles["cta-container"]}>
          <div className={styles["register-cta"]}>
            <a style={{cursor: "auto"}} href="https://gdg.community.dev/gdg-on-campus-shaheed-zulfikar-ali-bhutto-institute-of-science-and-technology-karachi-pakistan/">Explore Our Community</a>
          </div>
        </div>
      </div>

      {/* <div className={styles["desktop-img"]}>
      <img 
      width={400}
            src={MapSvg}
            alt="Google Developers Groups, On Campus Szabist"
          />
      </div>
       */}

    </section>
  );
};

export default NewHero;
